const appEnv = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development';

const API_BY_ENV = {
  production: 'https://api.nasehnutie.sk/',
  test: 'https://testapi.nasehnutie.sk/',
  development: 'http://localhost:8000/',
};

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || API_BY_ENV[appEnv] || API_BY_ENV.development;

// Deployment mode: 'full' (default) keeps the original SMS+bank+photo flow;
// 'email_only' uses the simplified email+password -> email-verify -> level 2
// flow. Set via VUE_APP_DEPLOYMENT_MODE at build time.
const deploymentMode = process.env.VUE_APP_DEPLOYMENT_MODE || 'full';

export const APP_ENV = appEnv;
export const API_BASE_URL = apiBaseUrl;
export const TOKEN_STORAGE_KEY = `TOKEN_STORAGE_KEY_${appEnv}`;
export const USERNAME_STORAGE_KEY = `USERNAME_STORAGE_KEY_${appEnv}`;
export const DEPLOYMENT_MODE = deploymentMode;

